import React, {useEffect, useMemo} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import {format} from 'date-fns';
import {Actions as CREATEACCOUNTACTIONS} from '../store/actions/createAccountActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import {Actions as WEBINARACTIONS} from '../store/actions/webinarActions';
import LeadForm from '../components/common/LeadForm'
import FeaturesSideBySide from '../components/features/FeaturesSideBySide'
import MaltaFeatures from '../components/features/MaltaFeatures'
import Team from '../components/team/Team'
import Pricing from '../components/pricing/Pricing'
import Testimonials from '../components/testimonials/Testimonials'
import Security from '../components/security/Security'

import WebinarCard from '../components/webinars/WebinarCard'


import MaltaFlag from '../assets/flags/malta.svg';
import {useParams} from "react-router";
import SeoHeaders from "../components/SeoHeaders";

const EMAILLIST = 9

function WebinarSeries({
  webinars,
  userInList,
  contactInList,
  getEventbriteEvents,
  profile,
}) {
  let { country } = useParams();


  const webinarsThisCountry = useMemo(() => {
    return webinars.filter(w => !w.country || (w.country == country))
  })

  useEffect(() => {
    // load initial data required for anywhere
    if (profile && profile.email){
      contactInList({
        email: profile.email,
        list: EMAILLIST
      })
    }
  },[profile && profile.email]);

  useEffect(() => {
    getEventbriteEvents();
  }, []);

  return (

    <React.Fragment>
      <SeoHeaders
          title={"[country] Payroll Webinars | Buddy"}
          description={"A series of HR &amp; Payroll related webinars to help you dive deeper into [country] Payroll."}
      />

      <main className="mt-8 sm:mt-16 md:mt-8 mb-8 sm:mb-12 md:mb-12 lg:mb-16">
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
              <div>
                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                  Buddy 
                  <br />
                  <span className="text-orange-400">Webinar Series</span>
                </h1>
                <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                  Whilst payroll software abstracts many complexities of payroll, sometimes your payroll knowledge will still be tested.
                  <br/> This series of webinars aims to provide additional knowledge you can leverage in your day to day duties.
                </p>
                {/*<p className="mt-8 text-sm text-white uppercase tracking-wide font-semibold sm:mt-10">Used by</p>
                <div className="mt-5 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                  <div className="flex flex-wrap items-start justify-between">
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={mcDonaldsLogo} alt="Mc Donalds"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={myokaLogo} alt="Myoka Spas"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={skySpiritLogo} alt="Sky Spirit"/>
                    </div>
                  </div>
                </div>*/}
              </div>
            </div>
            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6">

              {/* userInList &&
                <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg" id="leadForm">
                  <div className="px-4 py-8 sm:px-10">


                    <div>
                      <p className="text-base text-gray-600 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">{profile && ((profile.givenName && profile.givenName !== "_") || (profile.name && profile.name !== "_")) ? profile.givenName || profile.name : ''}, we've registered your interest for this webinar.</p>
                      <p className="text-base text-gray-600 sm:mt-5">In a few minutes you shall recieve an email to confirm your registration.</p>
                    </div>
                  </div>
                </div>
              */}

              { !userInList && <LeadForm list={EMAILLIST} ctaText="Subscribe to Webinar Series"/> } 
            </div>
          </div>
        </div>
      </main>

      <div className="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-12 lg:pb-28 lg:px-8">
        <div className="absolute inset-0">
          <div className="bg-white h-1/3 sm:h-2/3"></div>
        </div>
        {webinarsThisCountry.filter(w => w.date > new Date().toISOString()).length > 0 &&
          <div className="relative max-w-7xl mx-auto">
            <div className="text-center">
              <h2 className="text-3xl leading-9 tracking-tight font-extrabold text-gray-900 sm:text-4xl sm:leading-10">
                Upcoming Webinars
              </h2>
              <p className="mt-3 max-w-2xl mx-auto text-xl leading-7 text-gray-500 sm:mt-4">
                Discover Payroll with Buddy through these upcoming webinars.
              </p>
            </div>
            <div className="mt-12 mb-5 grid gap-5 max-w-lg mx-auto lg:grid-cols-3 lg:max-w-none">
              {webinarsThisCountry.filter(w => w.date > new Date().toISOString()).map(webinar => (
                <WebinarCard webinar={webinar} country={country}/>
              ))}
            </div>
          </div>
        }
        <div className="relative max-w-7xl mx-auto pt-8">
          <div className="text-center">
            <h2 className="text-3xl leading-9 tracking-tight font-extrabold text-gray-900 sm:text-4xl sm:leading-10">
              Past Webinars
            </h2>
            <p className="mt-3 max-w-2xl mx-auto text-xl leading-7 text-gray-500 sm:mt-4">
              These are some of the webinars we've conducted in the past.
            </p>
          </div>
          <div className="mt-12 grid gap-5 max-w-lg mx-auto lg:grid-cols-3 lg:max-w-none">
            {webinarsThisCountry
                .filter(w => w.date < new Date().toISOString() || w.onDemand)
                .reverse()
                .map(webinar => (
                  <WebinarCard webinar={webinar} country={country}/>
                ))
            }
          </div>
        </div>
      </div>

    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my

  const profile = state && state.my && state.my.profile  || localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

  const userInList = state.createAccount && state.createAccount.inList && state.createAccount.inList.find( item => item == EMAILLIST)

  return {
    userInList,
    webinars: state.webinars.list.filter(w => w.onlineEvent),
    profile
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  contactInList: (data) => dispatch(CREATEACCOUNTACTIONS.contactInList(data)),
  getEventbriteEvents: () => dispatch(WEBINARACTIONS.getEventbriteEvents()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WebinarSeries) 
